// bank_promptpay_v1: สร้าง payload PromptPay QR (EMVCo standard) สำหรับ render เป็น QR
// รองรับ: เบอร์มือถือ (10 หลัก) และเลขบัตรปชช./ผู้เสียภาษี (13 หลัก) + ใส่ยอดเงิน (dynamic)

function tlv(id, value) {
  var v = String(value);
  var len = String(v.length).padStart(2, '0');
  return id + len + v;
}

function crc16(payload) {
  var crc = 0xFFFF;
  for (var i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8;
    for (var j = 0; j < 8; j++) {
      crc = (crc & 0x8000) ? ((crc << 1) ^ 0x1021) : (crc << 1);
      crc &= 0xFFFF;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, '0');
}

// คืน { tag, value } ของ merchant identifier
function formatTarget(id) {
  var digits = String(id || '').replace(/\D/g, '');
  if (digits.length === 13) {
    // เลขบัตรประชาชน / เลขผู้เสียภาษี
    return { tag: '02', value: digits };
  }
  // เบอร์มือถือ: 0066 + เบอร์ (ตัด 0 นำหน้า) รวม 13 หลัก
  var phone = digits;
  if (phone.length === 10 && phone.charAt(0) === '0') phone = phone.slice(1);
  return { tag: '01', value: '0066' + phone.padStart(9, '0') };
}

// PromptPay (Tag 29) — เบอร์มือถือ / เลขบัตร ปชช.
export function promptpayPayload(id, amount) {
  var target = formatTarget(id);
  var merchant = tlv('00', 'A000000677010111') + tlv(target.tag, target.value);
  var hasAmount = amount != null && !isNaN(Number(amount)) && Number(amount) > 0;
  var payload =
    tlv('00', '01') +
    tlv('01', hasAmount ? '12' : '11') +
    tlv('29', merchant) +
    tlv('53', '764') +
    (hasAmount ? tlv('54', Number(amount).toFixed(2)) : '') +
    tlv('58', 'TH');
  payload += '6304';
  return payload + crc16(payload);
}

// Thai QR Bill Payment (Tag 30) — Biller ID 15 หลัก (แม่มณี / ร้านค้า). ref1 ไม่บังคับ
export function billPaymentPayload(billerId, amount, ref1) {
  var biller = String(billerId || '').replace(/\D/g, '');
  var merchant = tlv('00', 'A000000677010112') + tlv('01', biller) + (ref1 ? tlv('02', String(ref1).replace(/[^A-Za-z0-9]/g, '')) : '');
  var hasAmount = amount != null && !isNaN(Number(amount)) && Number(amount) > 0;
  var payload =
    tlv('00', '01') +
    tlv('01', hasAmount ? '12' : '11') +
    tlv('30', merchant) +
    tlv('53', '764') +
    (hasAmount ? tlv('54', Number(amount).toFixed(2)) : '') +
    tlv('58', 'TH');
  payload += '6304';
  return payload + crc16(payload);
}

// เลือกชนิดตาม type: 'biller' → Bill Payment (tag 30) แบบ STATIC (ไม่ใส่ยอด — แม่มณีเป็น QR ไม่ระบุยอด), อื่นๆ → PromptPay (tag 29) ใส่ยอดได้
export function paymentQrPayload(id, amount, type, ref1) {
  if (type === 'biller') return billPaymentPayload(id, null, ref1); /* biller_qr_static_v1: แม่มณี = static ไม่ใส่ยอด */
  return promptpayPayload(id, amount);
}

// qr_amount_v1: แยก TLV ระดับบนสุด
function parseTLV(s) {
  var out = [], i = 0;
  while (i + 4 <= s.length) {
    var tag = s.slice(i, i + 2);
    var len = parseInt(s.slice(i + 2, i + 4), 10);
    if (isNaN(len)) break;
    out.push({ tag: tag, val: s.slice(i + 4, i + 4 + len) });
    i += 4 + len;
  }
  return out;
}

// qr_amount_v1: ฉีดยอดเงินเข้า Thai QR payload ที่มีอยู่ (static → dynamic) รักษาโครงสร้างเดิมทุก tag
// ตั้ง POI(01)=12, แทรก/แทนที่ tag 54 = amount (หลัง tag 53), คำนวณ CRC(63) ใหม่
export function injectAmount(rawPayload, amount) {
  var a = Number(amount);
  if (!rawPayload || isNaN(a) || a <= 0) return rawPayload || '';
  var body = String(rawPayload).trim();
  if (!/^000201/.test(body)) return body; // ไม่ใช่ Thai QR → คืนของเดิม
  var items = parseTLV(body).filter(function (t) { return t.tag !== '63'; });
  var f54 = false;
  for (var k = 0; k < items.length; k++) {
    if (items[k].tag === '01') items[k].val = '12';
    if (items[k].tag === '54') { items[k].val = a.toFixed(2); f54 = true; }
  }
  var out = '';
  for (var m = 0; m < items.length; m++) {
    out += tlv(items[m].tag, items[m].val);
    if (!f54 && items[m].tag === '53') { out += tlv('54', a.toFixed(2)); f54 = true; }
  }
  if (!f54) out += tlv('54', a.toFixed(2));
  out += '6304';
  return out + crc16(out);
}
